export default {
  darkBlue: 'hsl(209, 23%, 22%)',
  veryDarkBlueBg: 'hsl(207, 26%, 17%)',
  veryDarkBlueTxt: 'hsl(200, 15%, 8%)',
  darkGray: 'hsl(0, 0%, 52%)',
  veryLightGray: 'hsl(0, 0%, 98%)',
  white: 'hsl(0, 0%, 100%)',
};
